import * as React from "react";
import PropTypes from "prop-types";
import { Box } from "rebass";

const BurgerLine = ({ top, left, transform, transition, ...rest }) => (
  <Box
    {...rest}
    bg="white"
    css={{
      height: "2px",
      position: "absolute",
      top,
      left,
      transform,
      transition,
      transformOrigin: "0 0 0"
    }}
  />
);

BurgerLine.propTypes = {
  top: PropTypes.string,
  left: PropTypes.string,
  transform: PropTypes.string.isRequired,
  transition: PropTypes.string.isRequired
};

BurgerLine.defaultProps = {
  top: 0,
  left: 0
};

export default BurgerLine;
